export function formatLocation(location) {
   if (location == null) {
      return "";
   }
   let formated = location.name;
   formated += `, ${location.address}`;
   formated += `, ${location.city}`;

   return formated;
}


// WEBPACK FOOTER //
// ./src/utils/location.js